import { Box } from "@mui/material";

import { useDealContext } from "../../deal/context";
import { CompanyTitle } from "../components/CompanyTitle";
import { FeedbackList } from "../components/feedback/FeedbackList";


export const CompanyFeedback = () => {
    const { dealContext } = useDealContext();

    const project = dealContext.project;
    const viewerRole = dealContext.role;


    return (
        <Box>
            <CompanyTitle
                viewerRole={viewerRole}
                project={project}
                section="Ideas"
                subheading="Review and interact with ideas from your advisors"
            />
            <FeedbackList />
        </Box>
    );
};